<template>
  <b-form :ref="getScope()" :data-vv-scope="getScope()" @submit.prevent @keyup.enter="$_handleOk">
    <b-modal
      id="updateModal"
      modal-class="optimizer-modal"
      centered
      @ok="$_handleOk"
      @show="$_clear"
      @hidden="$_handleClose"
      ref="modal"
    >
      <!-- Modal Header -->
      <template slot="modal-header">
        <h2 class="modal-header__title">{{ $c_title }}</h2>

        <svg class="modal-header__close-icon" @click="hide" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L13 13" stroke="#546582" stroke-width="2" stroke-linecap="round" />
          <path d="M13 1L1 13" stroke="#546582" stroke-width="2" stroke-linecap="round" />
        </svg>
      </template>

      <b-form-group v-if="$c_options.length > 0" :state="hasError('input')">
        <b-input-group>
          <b-input-group-addon v-if="left" class="text-center" slot="left" v-html="left">Bid Value</b-input-group-addon>
          <!-- <b-form-select
            v-model="type"
            :data-vv-as="$_getProp('fieldName')"
            v-validate="'required'"
            :options="$c_options"
          /> -->
          <vue-opti-select-light
            class="optimizer-select w-100"
            name="type"
            :data-vv-as="$_getProp('fieldName')"
            v-validate="'required'"
            :options="$c_options"
            unique-key="value"
            label-key="text"
            :value="type"
            single
            button-block
            @change="(option) => type = option.value"
          />
          <b-input-group-addon v-if="right" class="text-center" slot="right" v-html="$_getProp('right')"></b-input-group-addon>
        </b-input-group>
        <small slot="invalid-feedback">{{ getError('input') }}</small>
      </b-form-group>
      <b-form-group v-if="type != 'unlimited' && $c_options.length > 0" :state="hasError('input')">
        <b-input-group>
          <b-input-group-addon v-if="left" class="text-center" slot="left" v-html="left"></b-input-group-addon>
          <b-form-input
            ref="input"
            class="optimizer-form-input"
            v-model="value"
            :data-vv-as="$_getProp('fieldName')"
            v-validate="'required'"
            type="number"
            name="input"
            :min="min"
            :max="max"
            :step="step"
          >
          </b-form-input>
          <b-input-group-addon v-if="right" class="text-center" slot="right" v-html="$_getProp('right')"></b-input-group-addon>
        </b-input-group>
        <small slot="invalid-feedback">{{ getError('input') }}</small>
      </b-form-group>
      <div v-if="['Evadav', 'Kadam'].includes(campaign.traffic_source_unique_name) && fieldName === 'byCountry'">
        <div v-for="(item, index) in campaign.byCountry" :key="index">
          <b-form-fieldset
            :label="item.country"
            :label-cols="4"
            :horizontal="true"
          >
            <b-form-input type="number" :value="item.countryBid" @input="$_updateCountryValue(item, $event)"></b-form-input>
          </b-form-fieldset>
        </div>
      </div>

      <!-- Modal Footer -->
      <template slot="modal-footer">
        <b-btn class="secondary-button" @click="hide">Cancel</b-btn>
        <b-btn class="primary-button" @click="$_handleOk">Save</b-btn>
      </template>
    </b-modal>
  </b-form>
</template>

<script>
const scope = 'updateModal';
export default {
  name: 'UpdateModal',
  props: {
    fieldName: { type: String, default: 'Bid' },
    campaign: { type: Object, default: null },
    supportedTypes: { type: Array, default: () => [] },
    min: { type: Number, default: 0 },
    max: { type: [Number, Boolean], default: false },
    step: { type: Number, default: 1 },
    left: { type: [String, null], default: null },
    right: { type: [String, null], default: null },
    maxLimitWarning: { type: [Number, null], default: null },
    handler: { type: Function, default: async () => false },
    options: { type: Array, default: () => [] },
  },
  data() {
    return {
      input: null,
      localProps: {
        right: null,
        title: null,
        placeholder: null,
        fieldName: null,
        maxLimitWarning: null,
      },
      value: null,
      type: null,
      countryBid: {},
    };
  },
  computed: {
    $c_title() {
      switch (this.fieldName) {
        case 'cpc':
          return 'Edit Campaign Bid';
        case 'budget':
          return 'Edit Campaign Budget';
        case 'daily_budget':
          return 'Edit Campaign Daily Budget';
        case 'byCountry':
          return 'Edit Campaign Country Bid';
        default:
          return 'Edit Campaign Bid';
      }
    },

    $c_options() {
      switch (this.fieldName) {
        case 'cpc':
          return this.options;
        case 'budget':
          return [
            {
              value: 'unlimited',
              text: 'UNLIMITED',
            },
            {
              value: 'limited',
              text: 'LIMITED',
            },
          ];
        case 'daily_budget':
          return [
            {
              value: 'unlimited',
              text: 'UNLIMITED',
            },
            {
              value: 'limited',
              text: 'LIMITED',
            },
          ];
        default:
          return [];
      }
    },
  },
  methods: {
    show(field, props) {
      if (props) Object.keys(this.localProps).forEach((key) => { if (props[key]) this.localProps[key] = props[key]; });
      this.type = props[this._getFieldType(field)];
      this.value = props[field] > 0 ? props[field] : 0;
      this.$refs.modal.show();
    },
    $_updateCountryValue(item, event) {
      const newCountryBids = this.countryBid;
      newCountryBids[item.country] = event;
      this.countryBid = newCountryBids;
    },
    hide() {
      this.$refs.modal.hide();
    },
    getUpdatedBids() {
      const countryBids = this.countryBid;
      const campaignBids = this.campaign.byCountry.filter((item) => !Object.keys(countryBids).includes(item.country));
      Object.keys(countryBids).forEach((country) => {
        campaignBids.push({
          country,
          countryBid: parseFloat(countryBids[country]),
        });
      });
      return campaignBids;
    },
    async $_handleOk(evt) {
      evt.preventDefault();
      await this.$_submit();
    },

    async $_submit() {
      const isValid = await this.$validator.validateAll(this.getScope());
      if (isValid) {
        const acceptMaxLimit = await this.$_validateLimits();
        if (acceptMaxLimit) {
          if (this.fieldName === 'byCountry') {
            const countryBids = this.getUpdatedBids();
            this.$emit('updateCountryBid', this.campaign, countryBids, null);
          } else {
            this.$emit('updateField', this.fieldName, this.value, this.type);
          }
          this.$_clear();
          this.hide();
        }
      }
    },
    async $_validateLimits() {
      if (this.$_getProp('maxLimitWarning') && parseFloat(this.input) >= this.$_getProp('maxLimitWarning')) {
        const swal = await this.$swal({
          title: `${this.$_getProp('fieldName')} seems unusually high!`,
          type: 'warning',
          allowOutsideClick: false,
          shodatawCancelButton: true,
          confirmButtonText: 'Keep Anyway',
          cancelButtonText: 'Reset',
        });
        if (swal.value !== true) this.input = null;
        return swal.value;
      }
      return true;
    },
    $_clear() {
      this.input = '';
      this.$validator.reset(this.getScope());
    },
    $_handleClose() {
      Object.keys(this.localProps).forEach((key) => { this.localProps[key] = null; });
    },
    $_getProp(name) {
      return this.localProps[name] || this[name];
    },
    getScope() {
      return scope;
    },
    hasError(name) {
      return this.$validator.errors.has(`${scope}.${name}`) ? 'invalid' : null;
    },
    getError(name) {
      return this.$validator.errors.first(`${scope}.${name}`);
    },
    _getFieldType(field) {
      const fieldTypes = {
        cpc: 'bid_strategy',
        budget: 'budget_type',
        daily_budget: 'daily_budget_type',
      };
      return fieldTypes[field];
    },
  },
};
</script>

<style lang="scss">
#updateModal {
  .input-group-addon, .input-group-btn {
    min-width: 20px !important;
  }
}
@media (min-width: 576px) {
  #updateModal .modal-dialog {
        max-width: 500px !important;
  }
}
</style>
